import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import {Component} from "react";
import {Modal} from "react-bootstrap";

let source = axios.CancelToken.source();

class Movement_by_allocationveh extends Component {

    constructor() {
        super();
        this.state = {
            stock: 'nav-item',
            objs: [],
            objsload: false,

            reports: [],
            reportload: false,

            stdate:'',
            eddate:'',
            sttime:'',
            edtime:'',
            id:-1,

            cushow:false,
            remark:'',
            iscontacted:'1',
        }
    }
    componentDidMount() {
        let params = (new URL(document.location)).searchParams;
        let veh_id = params.get("id")
        let st = params.get("st");
        let ed = params.get("ed");
        this.setState({
            stdate:st,
            eddate:ed,
            id:veh_id,
        },()=>this.report(1))
    }
    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    tabledata=()=> {
        let retdata = null;
        if (this.state.reportload) {
            let count = 0;
            retdata =
                <>
                    <table className="table table-head-fixed text-nowrap">
                        <tr>
                            <th colSpan={10}><a href="" onClick={(event)=>this.datemgt(event)}>Date Management</a></th>
                        </tr>
                        <tr>
                            <th colSpan={10}><a href="" onClick={(event)=>this.showcu(event)}>Driver Contact</a></th>
                        </tr>
                        <tr>
                            <th colSpan={10}>Previous Order</th>
                        </tr>
                        <tr>
                            <th>Route</th>
                            <td>{this.state.reports.prv.org}-{this.state.reports.prv.des}</td>
                            <th>Sale Type</th>
                            <td>{this.state.reports.prv.sale_type}</td>
                            <th>Cargo</th>
                            <td>{this.state.reports.prv.cargo_id}</td>
                            <th>Customer</th>
                            <td>{this.state.reports.prv.customer_id}</td>
                            <th></th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Allocation</th>
                            <td>{this.state.reports.prv.dateofallocation}</td>
                            <th>Arrival</th>
                            <td>{this.state.reports.prv.dateofarivalatloadpoint}</td>
                            <th>Loading</th>
                            <td>{this.state.reports.prv.dateofloading}</td>
                            <th>Arrival Offloading</th>
                            <td>{this.state.reports.prv.dateofarivalatoffloadpoint}</td>
                            <th>Offloading</th>
                            <td>{this.state.reports.datas.dateofoffloading}</td>
                        </tr>

                        <tr>
                            <th colSpan={10}>Current Order</th>
                        </tr>
                        <tr>
                            <th>Route</th>
                            <td>{this.state.reports.datas.org}-{this.state.reports.datas.des}</td>
                            <th>Sale Type</th>
                            <td>{this.state.reports.datas.sale_type}</td>
                            <th>Cargo</th>
                            <td>{this.state.reports.datas.cargo_id}</td>
                            <th>Customer</th>
                            <td>{this.state.reports.datas.customer_id}</td>
                            <th></th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Allocation</th>
                            <td>{this.state.reports.datas.dateofallocation}</td>
                            <th>Arrival</th>
                            <td>{this.state.reports.datas.dateofarivalatloadpoint}</td>
                            <th>Loading</th>
                            <td>{this.state.reports.datas.dateofloading}</td>
                            <th>Arrival Offloading</th>
                            <td>{this.state.reports.datas.dateofarivalatoffloadpoint}</td>
                            <th>Offloading</th>
                            <td>{this.state.reports.datas.dateofoffloading}</td>
                        </tr>
                    </table>
                </>
        }
        return (<>{retdata}</>)
    }
    tabledata2=()=> {
        let retdata = null;
        if (this.state.reportload) {
            let count = 0;
            retdata = this.state.reports.movs.map(value => {
                count = count + 1
                return (<tr style={{backgroundColor: value.color}}>
                    <td>{count}</td>
                    <td>{value.plateno}</td>
                    <td>{value.sttime}</td>
                    <td>{value.stloc}</td>
                    <td>{value.edtime}</td>
                    <td>{value.edloc}</td>
                    <td>{value.dur}</td>
                    <td>{value.km}</td>
                    <td>{value.tatloc}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }
    tabledata3=()=> {
        let retdata = null;
        if (this.state.reportload) {
            let count = 0;
            retdata = this.state.reports.locs.map(value => {
                count = count + 1
                return (<tr style={{backgroundColor: value.color}}>
                    <td>{count}</td>
                    <td>{value.loc}</td>
                    <td>{value.dur}</td>
                    <td>{value.time}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }
    tabledata4=()=> {
        let retdata = null;
        if (this.state.reportload) {
            let count = 0;
            retdata = this.state.reports.contacts.map(value => {
                count = count + 1
                return (<tr>
                    <td>{value.remark}</td>
                    <td>{value.remark_by}</td>
                    <td>{value.remark_date}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }

    showcu = (event) => {
        event.preventDefault()
        this.setState({
            cushow: true,
        })
    }
    hidecu = () => {
        this.setState({
            cushow: false,
        })
    }
    modalcu = () => {
        return (<Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.cushow}
                onHide={this.hidecu}>
                <Modal.Header><h4>Driver Contact Form</h4></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3 className="card-title">Driver Informtion</h3>
                                </div>
                                <form>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Contacted</label>
                                                        <select className="form-control" name="iscontacted"
                                                               onChange={this.inputmgt} value={this.state.iscontacted}>
                                                            <option value="1">Yes</option>
                                                            <option value="1">No</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Remark</label>
                                                        <textarea className="form-control" type="text" name="remark"
                                                               onChange={this.inputmgt} rows={10}>
                                                            {this.state.remark}
                                                        </textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <button type="submit" className="btn btn-primary"
                                                onClick={event => this.submitcu(event)}>Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
    submitcu = (event) => {
        event.preventDefault()
        let baseurl = myconfig.create_remark;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            allocateveh_id:this.state.id,
            remark:this.state.remark,
            iscontacted:this.state.iscontacted,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                Swal.fire({
                    title: 'success!',
                    text: res.data.msg,
                    icon: 'success',
                    confirmButtonText: 'Okay'
                }).then(value => {
                    this.report(1)
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    getreport = (event,reporttype) => {
        event.preventDefault()
        this.report(reporttype)
    }
    report=(reporttype)=>{
        this.setState({
            reports: [],
            reportload: false,
            cushow:false,
            remark:'',
            iscontacted:'1',
        })
        let baseurl = myconfig.get_movement_by_allocationveh;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            stdate: this.state.stdate,
            eddate: this.state.eddate,
            sttime: this.state.sttime,
            edtime: this.state.edtime,
            id: this.state.id,
            reporttype: reporttype,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                console.log(res.data)
                console.log(res.data.ret_stdate)
                this.setState({
                    reports: res.data,
                    stdate: res.data.ret_stdate,
                    eddate: res.data.ret_eddate,
                    sttime: res.data.ret_sttime,
                    edtime: res.data.ret_edtime,
                    reportload: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });

    }
    datemgt = (event) => {
        event.preventDefault();
        let url=myconfig.redirectodate_v2+"?id="+this.state.id
        const datewindow = window.open(url, "datemgt", "width=500,height=500",true);
    }
    render() {
        return (
            <>
                <Nav type="movement_by_allocationveh"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Movement Allocation Report</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={myconfig.urlwelcome}>Home</a>
                                        </li>
                                        <li className="breadcrumb-item active">Movement Allocation</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title">Report Criteria</h3>
                                            <div className="card-tools">
                                                <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="col-md-8">
                                                <div className="card card-primary">
                                                    <div className="card-header">
                                                        <h3 className="card-title">Report Criteria</h3>
                                                    </div>
                                                    <form>
                                                        <div className="card-body">
                                                            <div className="col-9">
                                                                <div className="form-group">
                                                                    <label>Start Date</label>
                                                                    <input className="form-control" type="date" name="stdate"
                                                                           onChange={this.inputmgt} value={this.state.stdate}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-3">
                                                                <div className="form-group">
                                                                    <label>Start time</label>
                                                                    <input className="form-control" type="text" name="sttime"
                                                                           onChange={this.inputmgt} value={this.state.sttime} placeholder="HH:MM"/>
                                                                </div>
                                                            </div>
                                                            <div className="col-9">
                                                                <div className="form-group">
                                                                    <label>End Date</label>
                                                                    <input className="form-control" type="date" name="eddate"
                                                                           onChange={this.inputmgt} value={this.state.eddate}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-3">
                                                                <div className="form-group">
                                                                    <label>End time</label>
                                                                    <input className="form-control" type="text" name="edtime"
                                                                           onChange={this.inputmgt} value={this.state.edtime} placeholder="HH:MM"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="card-footer">
                                                            <button type="submit" className="btn btn-primary" onClick={(event => this.getreport(event,2))}>Get report</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="card card-primary">
                                                        <div className="card-header">
                                                            <h3 className="card-title">Location Stoppage Summary</h3>
                                                        </div>
                                                        <div className="card-body table-responsive pt-3 px-2"  style={{height: '250px'}}>
                                                            <table className="table table-head-fixed text-nowrap">
                                                                <thead>
                                                                <th>#</th>
                                                                <th width="33.5%">Location</th>
                                                                <th>Duration</th>
                                                                <th>Time</th>
                                                                </thead>
                                                                <tbody>
                                                                {this.tabledata3()}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="card card-primary">
                                                        <div className="card-header">
                                                            <h3 className="card-title">Driver Contact Information</h3>
                                                        </div>
                                                        <div className="card-body table-responsive pt-3 px-2"  style={{height: '200px'}}>
                                                            <table className="table table-head-fixed text-nowrap">
                                                                <thead>
                                                                <th>Remark</th>
                                                                <th>Remark By</th>
                                                                <th>Remark Date</th>
                                                                </thead>
                                                                <tbody>
                                                                {this.tabledata4()}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card-body table-responsive pt-3 px-2">
                                                {this.tabledata()}
                                                <table className="table table-head-fixed text-nowrap">
                                                    <thead>
                                                    <th>#</th>
                                                    <th>Truck</th>
                                                    <th>Start Time</th>
                                                    <th>Start Location</th>
                                                    <th>End Time</th>
                                                    <th>End Location</th>
                                                    <th>Duration</th>
                                                    <th>Millage</th>
                                                    <th>Time at Location</th>
                                                    </thead>
                                                    <tbody>
                                                    {this.tabledata2()}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        {/* /.card-body */}
                                    </div>
                                    {/* /.card */}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                {this.modalcu()}
            </>
        )
    }
}

export default Movement_by_allocationveh;
